import { bi } from "@/lib/i18n";

export function upcomingDeadlines(cvs, lang, horizonDays = 30) {
  return cvs
    .flatMap((cv) => (cv.upcoming || []).map((x) => ({ ...x, cvId: cv.id, cvTitle: cv.personal?.fullName || cv.title, title: bi(x.title, lang), days: x.daysLeft })))
    .filter((x) => x.days <= horizonDays)
    .sort((a, b) => a.days - b.days);
}
